import { useBloomreach } from '../context/context.js';
import { getConfiguratorDocument } from '../utils/get-configurator-document.js';
import { getVtoBanner } from '../utils/get-vto-banner.js';
import { getBrandPromotions } from '../utils/get-brand-promotions.js';
import { getComponentByPath } from '../utils/get-component-by-path.js';
import { getContentByRef } from '../utils/get-content-by-ref.js';

const emptyContent = {};
function useBloomreachPdpContent() {
    var ref, ref1, ref2, ref3, ref4;
    const { pageModel  } = useBloomreach();
    if (!(pageModel === null || pageModel === void 0 ? void 0 : (ref = pageModel.page) === null || ref === void 0 ? void 0 : ref.models)) {
        return emptyContent;
    }
    const mainComponent = getComponentByPath('main', pageModel);
    const ref5 = mainComponent === null || mainComponent === void 0 ? void 0 : (ref1 = mainComponent.models) === null || ref1 === void 0 ? void 0 : ref1.document.$ref;
    const content = getContentByRef(ref5, pageModel);
    if (!content) {
        console.warn(`Cannot find main content for ProductDetail pageModel. Got: ${content} for $ref: ${ref5}`);
        return emptyContent;
    }
    const { usps , instructions , noAddonsImage , additionalUsps , disclaimer , configuratorDocument: configuratorDocumentRef , brandCollectionDocument ,  } = content;
    const configuratorDocument = getConfiguratorDocument(configuratorDocumentRef, pageModel, noAddonsImage);
    const modal = getModalContent(mainComponent, pageModel);
    const sizeGuideDocumentRef = content === null || content === void 0 ? void 0 : (ref2 = content.sizeGuideDocument) === null || ref2 === void 0 ? void 0 : ref2.$ref;
    const sizeGuideDocument = getContentByRef(sizeGuideDocumentRef, pageModel);
    const vtoBanner = getVtoBanner(pageModel, (ref3 = content.vtoBanner) === null || ref3 === void 0 ? void 0 : ref3.$ref);
    const brandPromotions = getBrandPromotions(brandCollectionDocument === null || brandCollectionDocument === void 0 ? void 0 : brandCollectionDocument.$ref, pageModel);
    var ref6;
    return {
        modalContent: (ref6 = modal === null || modal === void 0 ? void 0 : (ref4 = modal.content) === null || ref4 === void 0 ? void 0 : ref4.value) !== null && ref6 !== void 0 ? ref6 : '',
        instructions: instructions && {
            id: instructions.id,
            value: instructions.html,
            textColor: instructions.textColor,
            backgroundColor: instructions.backgroundColor
        },
        usps: usps.map(({ icon , text  })=>({
                icon,
                text
            })
        ),
        additionalUsps: additionalUsps.map(({ icon , text  })=>({
                icon,
                text
            })
        ),
        configuratorDocument,
        brandPromotions,
        vtoBanner,
        disclaimer,
        sizeGuideDocument: sizeGuideDocument && {
            findOutSizeCTA: sizeGuideDocument.findOutSizeCTA && {
                icon: sizeGuideDocument.findOutSizeCTA.icon,
                link: {
                    url: sizeGuideDocument.findOutSizeCTA.link.url,
                    label: sizeGuideDocument.findOutSizeCTA.link.label,
                    alt: sizeGuideDocument.findOutSizeCTA.link.alt,
                    openInNewWindow: sizeGuideDocument.findOutSizeCTA.link.openInNewWindow,
                    style: sizeGuideDocument.findOutSizeCTA.link.style
                }
            },
            findOutSizeDescription: sizeGuideDocument.findOutSizeDescription,
            findOutSizeImage: sizeGuideDocument.findOutSizeImage,
            findOutSizeSubtitle: sizeGuideDocument.findOutSizeSubtitle,
            findOutSizeTitle: sizeGuideDocument.findOutSizeTitle,
            measureDescription: sizeGuideDocument.measureDescription,
            measureDescriptionImage: sizeGuideDocument.measureDescriptionImage,
            measureImage: sizeGuideDocument.measureImage,
            measureSteps: sizeGuideDocument.measureSteps,
            measureTitle: sizeGuideDocument.measureTitle,
            sizeGuideSizeCompound: sizeGuideDocument.sizeGuideSizeCompound,
            sizeTitle: sizeGuideDocument.sizeTitle
        }
    };
}
function getModalContent(main, pageModel) {
    var ref9, ref7;
    const components = main === null || main === void 0 ? void 0 : (ref9 = main.components) === null || ref9 === void 0 ? void 0 : ref9.reduce((acc, cur)=>{
        return (cur === null || cur === void 0 ? void 0 : cur.components) ? [
            ...acc,
            ...cur === null || cur === void 0 ? void 0 : cur.components
        ] : acc;
    }, []);
    const modal = (components || []).find((c)=>{
        var ref, ref8;
        return c.name === 'richtext' && ((ref = c._meta) === null || ref === void 0 ? void 0 : (ref8 = ref.params) === null || ref8 === void 0 ? void 0 : ref8.template) === 'modal';
    });
    return modal && getContentByRef(modal === null || modal === void 0 ? void 0 : (ref7 = modal.models) === null || ref7 === void 0 ? void 0 : ref7.document.$ref, pageModel);
}

export { useBloomreachPdpContent };
//# sourceMappingURL=use-bloomreach-pdp-content.js.map
